var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.0596H4.16667C3.72464 18.0596 3.30072 17.884 2.98816 17.5714C2.6756 17.2589 2.5 16.8349 2.5 16.3929V4.72624C2.5 4.28421 2.6756 3.86029 2.98816 3.54773C3.30072 3.23516 3.72464 3.05957 4.16667 3.05957L7.5 3.05957M13.3333 14.7262L17.5 10.5596M17.5 10.5596L13.3333 6.3929M17.5 10.5596H7.5",
    stroke: "#363636",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconLogout);
export default __webpack_public_path__ + "static/media/nav-icon-logout.6258c0e9e9af087721cf8a81136f2b56.svg";
export { ForwardRef as ReactComponent };